import * as React from "react";
import Checkbox from "@mui/material/Checkbox";
import FormControlLabel from "@mui/material/FormControlLabel";
import { FormHelperText } from "@mui/material";
import { PatriotDeliveryChoice } from "../PatriotDeliveryChoice";

export const CheckBoxFieldType = ({
  config,
  formik,
}: {
  config: any;
  formik: any;
}) => {
  const hasInitializedField = React.useRef(false);

  React.useEffect(() => {
    if (!hasInitializedField.current) {
      hasInitializedField.current = true;
      const normalizedCurrentValue = normalizeCheckboxValue(
        formik.values[config.field]
      );
      if (formik.values[config.field] !== normalizedCurrentValue) {
        if (typeof formik.setFieldValue === "function") {
          formik.setFieldValue(config.field, normalizedCurrentValue, false);
        } else {
          formik.values[config.field] = normalizedCurrentValue;
        }
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Patriot forms (the only alarm form carrying patriot_send_video) replace
  // the send video / draw ignore zones checkboxes with one delivery choice:
  // it renders in place of patriot_send_video and owns draw_ignore_zones too.
  const isPatriotForm =
    !!formik.values && "patriot_send_video" in formik.values;

  if (isPatriotForm && config.field === "draw_ignore_zones") {
    return null;
  }

  if (isPatriotForm && config.field === "patriot_send_video") {
    const setField = (field: string, value: boolean) => {
      if (typeof formik.setFieldValue === "function") {
        formik.setFieldValue(field, value, false);
      } else {
        formik.values[field] = value;
      }
    };
    return (
      <div key={config.id} className="pb-2">
        <PatriotDeliveryChoice
          sendVideo={formik.values.patriot_send_video}
          drawIgnoreZones={formik.values.draw_ignore_zones}
          onChange={(values) => {
            setField("patriot_send_video", values.patriot_send_video);
            setField("draw_ignore_zones", values.draw_ignore_zones);
          }}
        />
      </div>
    );
  }

  return (
    <div key={config.id}>
      <FormControlLabel
        sx={{
          fontFamily: "Mulish",
          color: "#001943",
        }}
        label={config.label === "NAT Instance" ? "Whitelisting" : config.label}
        control={
          <Checkbox
            color="primary"
            checked={normalizeCheckboxValue(formik.values[config.field])}
            disabled={config.disabled}
            onChange={(item: any) => {
              if (typeof formik.setFieldValue === "function") {
                formik.setFieldValue(config.field, item.target.checked, false);
              } else {
                formik.values[config.field] = item.target.checked;
              }
            }}
          />
        }
      />
      <FormHelperText sx={{ width: 350 }}>
        {config.helperText.includes("NAT")
          ? config.helperText.replace("NAT", "Whitelisting")
          : config.helperText}
      </FormHelperText>
    </div>
  );
};

const normalizeCheckboxValue = (value: any): boolean => {
  if (value === true || value === "True") {
    return true;
  }
  if (
    value === false ||
    value === "False" ||
    value === "" ||
    typeof value === "undefined" ||
    value === null
  ) {
    return false;
  }
  return Boolean(value);
};
